import api, { ApiResponse } from "../api";
import {
  InboundMessageDetail,
  InboundMessageListResponse,
  InboundMessagesQuery,
  MimeBase64Response,
} from "./models";

function getErrorMessage(response: ApiResponse<unknown>): string {
  const err = response.getError?.();
  if (typeof err === "string") return err;
  if (err && typeof err === "object" && "message" in err) return String((err as { message: string }).message);
  return "Request failed";
}

class CommunicationsService {
  private static instance: CommunicationsService;

  private constructor() {}

  static getInstance(): CommunicationsService {
    if (!CommunicationsService.instance) {
      CommunicationsService.instance = new CommunicationsService();
    }
    return CommunicationsService.instance;
  }

  public getInboundMessages = async (
    query: InboundMessagesQuery
  ): Promise<InboundMessageListResponse> => {
    const params: Record<string, string | number | boolean> = {};
    if (query.next) params.next = query.next;
    if (query.pageSize != null) params.pageSize = query.pageSize;
    if (query.processingState) params.processingState = query.processingState;
    if (query.hasPendingReview != null) params.hasPendingReview = query.hasPendingReview;
    if (query.sender) params.sender = query.sender;

    const response = await api.get<InboundMessageListResponse>("/pickups-automation/communications/inbound-messages", {
      params,
    });
    if (!response.ok()) {
      throw new Error(getErrorMessage(response));
    }
    return response.data;
  };

  public getInboundMessage = async (id: number): Promise<InboundMessageDetail> => {
    const response = await api.get<InboundMessageDetail>(
      `/pickups-automation/communications/inbound-messages/${id}`
    );
    if (!response.ok()) {
      throw new Error(getErrorMessage(response));
    }
    return response.data;
  };

  public getMimeBase64 = async (id: number): Promise<string | null> => {
    const response = await api.get<MimeBase64Response>(
      `/pickups-automation/communications/inbound-messages/${id}/mime/base64`
    );
    if (response.status === 404) return null;
    if (!response.ok()) {
      throw new Error(getErrorMessage(response));
    }
    return response.data?.mime ?? null;
  };
}

export default CommunicationsService;
